<script lang="ts" setup>
import Icon from '@ui/components/icon.vue';
import MenuBadge, { type TopBarMenuBadgeInterface } from '@app/components/parts/topBar/menuBadge.vue';

const props = withDefaults(
    defineProps<{
        tab?: {
            text?: string;
            icon?: string;
            badge?: TopBarMenuBadgeInterface | null;
        };
        isOpen: boolean;
    }>(),
    {
        tab: () => {
            return {};
        },
    },
);
</script>
<template>
    <div
        class="relative flex items-center text-gray-500 group-hover:text-white"
        :class="props.tab.text ? '-ml-3 -mr-1.5 pr-1 lg:-ml-2 lg:pr-3' : 'px-1 lg:px-3'"
    >
        <span
            class="flex items-center justify-center rounded p-1"
            :class="[props.isOpen ? 'text-brand-400' : 'hover:text-white'].join(' ')"
        >
            <Icon
                :icon="tab.icon ? tab.icon : 'fas fa-chevron-down'"
                class="fill-current transition-transform"
                :class="[props.isOpen && 'rotate-180', props.tab.text ? 'scale-90' : ''].join(' ')"
            ></Icon>
        </span>
        <MenuBadge
            v-if="props.tab.badge"
            :badge="props.tab.badge"
            variant="tab-icon"
        ></MenuBadge>
    </div>
</template>
